import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import classes from './ContactIconHeader.module.css';
import {useState} from 'react';

const ContactIconHeader = ({type, info, iStyle, tStyle}) => {
	const types = {
		email: <EmailIcon sx={iStyle}/>,
		whatsapp: <WhatsAppIcon sx={iStyle}/>,
		phone: <LocalPhoneIcon sx={iStyle}/>
	};

	return (
		<div className={classes.container}>
			{types[type]}
			<p style={tStyle}>{info}</p>
		</div>
	);
};

export default ContactIconHeader;